module.exports = "../fonts/SFUIText-Light.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SFUIText-Light.otf
// module id = 577
// module chunks = 0